import { render, staticRenderFns } from "./BoardList.vue?vue&type=template&id=5d295e76&scoped=true"
import script from "./BoardList.vue?vue&type=script&lang=js"
export * from "./BoardList.vue?vue&type=script&lang=js"
import style0 from "./BoardList.vue?vue&type=style&index=0&id=5d295e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d295e76",
  null
  
)

export default component.exports